import { initializeStore } from '@seamless/store';
import { addConnectionAemEnvironmentConnection, connectionName, } from '@owc/connection-aem-environment';
/**
 * Read AEM environment
 */
export async function getAemEnvironmentData() {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
        await addConnectionAemEnvironmentConnection();
        const store = initializeStore();
        const listener = (state) => {
            resolve(state);
            store.unsubscribe(connectionName, listener);
        };
        await store.subscribe(connectionName, listener);
    });
}
